import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AreaService, JobTitleService } from 'src/app/api/services';
import { BusinessLineService } from 'src/app/api/services/business-line.service';
import { UserExperienceService } from 'src/app/api/services/user-experience.service';
import { MESSAGES } from 'src/app/core/constant/messages';
import { InputDateComponent } from 'src/app/shared/component/input-date/input-date.component';
import { InputSelectComponent } from 'src/app/shared/component/input-select/input-select.component';
import { InputTextComponent } from 'src/app/shared/component/input-text/input-text.component';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { BaseFormComponent } from 'src/app/shared/form/base-form.component';
import { SelectOption } from 'src/app/shared/model/select-option';
import { Experience } from 'src/app/shared/model/user-experince';
import { ToastService } from 'src/app/shared/service/toast.service';
import { dateRangeOrderValidator } from 'src/app/shared/validator/date-range-order.validator';
import { dateValidator } from 'src/app/shared/validator/dateValidator';
import { finalize } from 'rxjs';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextareaComponent } from 'src/app/shared/component/input-textarea/input-textarea.component';

@Component({
  selector: 'app-add-experince',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingButtonComponent,
    InputTextComponent,
    InputSelectComponent,
    InputDateComponent,
    InputTextareaComponent  
  ],
  templateUrl: './add-experience.component.html',
  styles: ``,
})
export class AddExperienceComponent
  extends BaseFormComponent
  implements OnInit
{
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<Experience>();

  experienceForm: FormGroup;
  loading: boolean = false;

  bussinessLines: SelectOption[] = [];
  jobTitles: SelectOption[] = [];
  areas: SelectOption[] = [];

  constructor(
    private fb: FormBuilder,
    private userExpService: UserExperienceService,
    private jobTitleService: JobTitleService,
    private bussinessLineService: BusinessLineService,
    private areaService: AreaService,
    toastService: ToastService
  ) {
    super(toastService);
    this.experienceForm = this.fb.group(
      {
        idJobTitle: ['', Validators.required],
        idBusinessLine: ['', Validators.required],
        idArea: ['', Validators.required],
        companyName: ['', Validators.required],
        functionsDescription: ['', Validators.required],
        fromProperty: ['', [Validators.required, dateValidator()]],
        until: ['', [Validators.required, dateValidator()]],
        references: this.fb.array([
          this.fb.group({
            fullNameContact: ['', Validators.required],
            telfContact: [
              '',
              [
                Validators.required,
                Validators.minLength(9),
                Validators.maxLength(9),
                Validators.pattern(/^[0-9]+$/),
              ],
            ],
          }),
        ]),
      },
      {
        validators: [dateRangeOrderValidator('fromProperty', 'until')],
      }
    );
  }

  ngOnInit(): void {
    this.loadCatalog(
      this.jobTitleService.tituloEmpleoGet(),
      (data) =>
        (this.jobTitles = data.dto.jobTitles.map((x: any) => ({
          value: x.idJobTitle,
          label: x.name,
        }))),
      MESSAGES.JOB_TITLE.GET_ALL_ERROR
    );

    this.loadCatalog(
      this.bussinessLineService.getBusinessLines(),
      (data) =>
        (this.bussinessLines = data.dto.businessLines.map((x: any) => ({
          value: x.idBusinessLine,
          label: x.description,
        }))),
      MESSAGES.BUSSINES_LINE.GET_ALL_ERROR
    );

    this.loadCatalog(
      this.areaService.areaGet(),
      (data) =>
        (this.areas = data.dto.areas.map((x: any) => ({
          value: x.idArea,
          label: x.name,
        }))),
      MESSAGES.AREA.GET_ALL_ERROR
    );
  }

  private loadCatalog(
    obs$: any,
    success: (data: any) => void,
    defaultMsg: string
  ) {
    obs$.subscribe({
      next: success,
      error: (err: any) =>
        this.toastService.showMessages(
          'error',
          err?.error?.listMessage || [defaultMsg]
        ),
    });
  }

  private createReferenceGroup(): FormGroup {
    return this.fb.group({
      fullNameContact: ['', Validators.required],
      telfContact: [
        '',
        [
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(9),
          Validators.pattern(/^[0-9]+$/),
        ],
      ],
    });
  }

  get references(): FormArray {
    return this.experienceForm.get('references') as FormArray;
  }

  addReference() {
    this.references.push(this.createReferenceGroup());
  }

  removeReference(index: number) {
    this.references.removeAt(index);
  }

  onSaveClick() {
    if (!this.validateForm(this.experienceForm)) return;

    const payload = {
      ...this.experienceForm.value,
      fromProperty: this.toBackendDate(this.experienceForm.value.fromProperty),
      until: this.toBackendDate(this.experienceForm.value.until),
    };

    this.loading = true;
    this.userExpService
      .createExperience(payload)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => {
          this.toastService.showMessages('success', [
            MESSAGES.USER.EXPERIENCE_SUCCES,
          ]);
          this.save.emit(res.dto);
          this.close.emit();
        },
        error: (err) => this.showApiError(err, MESSAGES.USER.EXPERIENCE_ERROR),
      });
  }

  onCloseClick() {
    this.close.emit();
  }

  private toBackendDate(value: string): string | null {
    if (!value) return null;
    const [d, m, y] = value.split('/');
    return `${y}-${m}-${d}`;
  }
}
